module.exports = __webpack_public_path__ + "static/media/proa_109.16fa9aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/proa_109.jpg
// module id = 127
// module chunks = 0